import { gql } from '@apollo/client'

export const REBALANCE_HISTORY_ITEM_QUERY = gql`
  query ($assetId: String, $first: Int, $skip: Int) {
    rebalanceHistoryItems(
      first: $first
      skip: $skip
      where: { asset: $assetId }
      orderBy: createdAt
      orderDirection: desc
    ) {
      id
      asset {
        assetId
      }
      tickLower
      tickUpper
      profit
      createdAt
    }
  }
`

export type RebalanceHistoryItem = {
  id: string
  asset: {
    assetId: string
  }
  tickLower: string
  tickUpper: string
  profit: string
  createdAt: string
}

export type RebalanceHistoryItems = {
  rebalanceHistoryItems: RebalanceHistoryItem[]
}
